import { useQuery, useMutation } from '@tanstack/react-query';
import { customerApi } from '../lib/api';

/**
 * Live wallet balance for the authenticated customer.
 * Refreshes every 30 s so the countdown / expiring-soon banner stays accurate.
 */
export function useWalletBalance(opts = {}) {
  return useQuery({
    queryKey: ['wallet-balance'],
    queryFn: () => customerApi.getWalletBalance(),
    select: (res) => res.data,
    refetchInterval: 30000,
    staleTime: 15000,
    ...opts,
  });
}

/**
 * Paginated wallet transaction history (newest first).
 */
export function useWalletTransactions(params = { page: 1, limit: 20 }) {
  return useQuery({
    queryKey: ['wallet-transactions', params],
    queryFn: () => customerApi.getWalletTransactions(params),
    select: (res) => res.data,
    refetchInterval: 60000,
  });
}

/**
 * Issue a fresh 60-second redemption QR JWT.
 * Each call produces a unique `jti` so the resulting QR can only be redeemed once.
 */
export function useGenerateWalletQR() {
  return useMutation({
    mutationFn: () => customerApi.generateWalletQR(),
  });
}
